module.exports = "<p>\n  sale works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/allocation/saledeed/sale/sale.component.html
// module id = ./src/app/allocation/saledeed/sale/sale.component.html
// module chunks = main